import { EventEmitter, Injectable } from '@angular/core';
import { ZONE } from '../zone/zone.service';

@Injectable({
  providedIn: 'root'
})
export class BoothTypeService {

  is_display_booth_type_register_component = false;
  boothTypeUpdate = new EventEmitter<BoothType>();

  downloadBoothType = new EventEmitter<boolean>();
  private _booth_type_data: BoothType = null;

  constructor() { }

  set set_booth_type_data(zone) {
    this._booth_type_data = zone;
  }

  get get_booth_type_data() {
    return this._booth_type_data;
  }
}

export interface BoothType {
  id: number;
  name: string;
}
